import React from 'react';
import { useTranslation } from 'react-i18next';
import { TitleHeader } from 'web-library';
import ResitListing from '../../modules/resit/components/@candidate/ResitListing';

const Listing = () => {
  const { t } = useTranslation();
  return (
    <>
      <TitleHeader title={t('resit->>ResitListing.Registered Exams')} />

      <ResitListing />
    </>
  );
};

export default Listing;
